var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockFastForward = function SvgClockFastForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F76B15",
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 0 6.223 13.028 1 1 0 0 1 1.554 1.258A9.98 9.98 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c5.134 0 9.365 3.87 9.935 8.851l.058-.058a1 1 0 0 1 1.414 1.414l-2 2a1 1 0 0 1-1.413 0l-2.001-2a1 1 0 0 1 1.414-1.414l.568.568A8 8 0 0 0 12 4m0 2a1 1 0 0 1 1 1v4.465l2.555 1.703a1 1 0 0 1-1.11 1.664l-3-2A1 1 0 0 1 11 12V7a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgClockFastForward;